import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Properties from './components/Properties';
import Footer from './components/Footer';
import Login from './pages/Login';
import authService from './services/authService';
import propertiesService from './services/propertiesService';
import ordersService from './services/ordersService';
import config from './config';
import Cart from './components/Cart';
import Pricing from './components/Pricing';
import cartService from './services/cartService';
import Referer from './components/Referer';
import FloatingCart from './components/FloatingCart';
import LoadingSpinner from './components/LoadingSpinner';
import AdminDashboard from './components/admin/AdminDashboard';
import ProductList from './components/admin/Products/ProductList';
import CategoryList from './components/admin/Products/CategoryList';
import PacksList from './components/admin/Packs/PacksList';
import UsersList from './components/admin/Users/UsersList';
import { OrdersPage } from './components/admin/Orders';
import SalesReport from './components/admin/reports/SalesReport';
import ImpersonationBanner from './/components/admin/Users/ImpersonationBanner';
import userRoleUtils from './utils/userRoleUtils';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import AdminPropertiesPage from './components/AdminPropertiesPage';
/* import PaymentManagement from './components/admin/Orders/PaymentManagement';
 */import SimplifiedPaymentManagement from './components/admin/Orders/SimplifiedPaymentManagement';
import { use } from 'react';
import Register from './components/Register';
import RoleList from './components/admin/Roles/RoleList';
import PermissionList from './components/admin/Perrmission/PermissionList';
import Inbox from './components/Inbox';
import AdminMessaging from './components/admin/AdminMessaging';
import AdminUserGroups from './components/admin/AdminUserGroups';
import { CartProvider } from './context/CartContext';
import eventBus from './utils/eventBus';
import UserProfile from './components/UserProfile';
import ServiceDashboard from './components/service/ServiceDashboard';
import ContactFormsList from './components/admin/ContactFormsList';
import InvoicesPage from './components/admin/Invoices/InvoicesPage';
import XeroIntegrationPage from './components/admin/Integrations/XeroIntegrationPage';
import NotificationSettingsPage from './components/admin/NotificationSettingsPage';
import StripeSettingsPage from './components/admin/StripeSettingsPage';




const calculateOrderStats = (orders = [], alldata = []) => {
  return {
    active: alldata.total,
    completed: orders.filter(order => order.order_status === 'Completed').length,
    failed: orders.filter(order => ['Failed', 'Cancelled'].includes(order.order_status)).length
  };
};

//if link is changed get again properties

const App = () => {
  const [sidebarOpen, setSidebarOpen] = useState(() =>
    typeof window === 'undefined' ? true : window.innerWidth >= 1024
  );
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [properties, setProperties] = useState([]);
  const [otherPropertiyData, setOtherPropertiyData] = useState(null);
  const [ordersData, setOrdersData] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const orderStats = calculateOrderStats(ordersData?.orders, ordersData?.orders_all);
  const [orderSheduled, setOrderSheduled] = useState([]);
  const [productCount, setProductCount] = useState(0);
  const [serviceMode, setServiceMode] = useState(() => {
    return localStorage.getItem('serviceMode') === 'true';
  });
  const isAdminOrImpersonating = () => {
    return userRoleUtils.isAdminOrImpersonating();
  };

  const toggleServiceMode = () => {
    const newMode = !serviceMode;
    localStorage.setItem('serviceMode', newMode);
    setServiceMode(newMode);
  };
  useEffect(() => {
    // Subscribe to cart updates
    const unsubscribe = eventBus.on('cart:updated', (updatedCart) => {
      setCartItems(updatedCart || {});
    });

    // Cleanup
    return () => {
      unsubscribe();
    };
  }, []);
  const isAdmin = () => {
    return userRoleUtils.isAdmin();
  };

  const getOrders = async () => {
    try {
      const ordersData = await ordersService.getAllOrders();
      setOrders(ordersData.orders_specific_count);
      setCartItems(ordersData.cart);
      setOrdersData(ordersData);
    } catch (error) {
      console.error('Error fetching orders:', error);
      // Handle error appropriately but don't log out
    }
  };

  // This should be added to your App.js component's checkAuth function
  // Replace your existing checkAuth function with this improved version

  const checkAuth = async () => {
    setLoading(true);

    try {
      // Check if token exists in localStorage
      if (authService.isAuthenticated()) {
        const userData = await authService.getCurrentUser();

        if (!userData) {
          // If no user data but token exists, token might be invalid
          setIsAuthenticated(false);
          setUser(null);
          setLoading(false);
          return;
        }

        setUser(userData);

        // Load user roles and permissions
        if (userData && userData.id) {
          try {
            await authService.loadUserRolesAndPermissions(userData.id);
          } catch (error) {
            console.error('Error loading user roles and permissions:', error);
          }
        }

        // Skip standard data loading for admin users to prevent unnecessary API calls
        if (userData && userData.role === 'admin') {
          setIsAuthenticated(true);
          setLoading(false);
          return;
        }

        // Handle impersonation case
        if (userRoleUtils.isImpersonating()) {
          console.log('User is impersonating, setting authenticated state');
        }
        // Ako korisnik ima samo "service" rolu, redirektuj ga odmah
        if (userData?.roles?.some(role => role.name === 'service') && userData?.roles?.some(role => !['admin', 'superadmin'].includes(role.name))) {
          setServiceMode(true);

          window.location.href = '/service-dashboard';
          return;
        }
        if (
          userData?.roles?.some(r => r.name === 'service') &&
          userData?.roles?.some(r => ['admin', 'superadmin'].includes(r.name))
        ) {
          const savedMode = localStorage.getItem('serviceMode');
          if (savedMode === 'true') {
            setServiceMode(true);
            window.location.href = '/service-dashboard';
            return;
          }
        }
        // Set authenticated state immediately
        setIsAuthenticated(true);

        // Use a try/catch for each data loading operation to prevent one failure from breaking everything
        try {
          // Fetch orders
          await getOrders();
        } catch (ordersError) {
          console.error('Error fetching orders:', ordersError);
        }

        try {
          // Fetch properties
          const propertiesData = await propertiesService.getAllProperties();

          // Check if the response contains properties data
          if (propertiesData && propertiesData.properties) {
            setProperties(propertiesData.properties);
            setOtherPropertiyData(propertiesData);

            // Handle scheduled orders
            if (propertiesData.order_schedule) {
              setOrderSheduled(propertiesData.order_schedule);

              // Add today's orders if they exist
              if (propertiesData.todayorders) {
                setOrderSheduled(prevScheduled => [...prevScheduled, ...propertiesData.todayorders]);
              }
            }

            // Handle cart items
            if (propertiesData.cart) {
              if (cartItems && cartItems.length === 0) {
                setCartItems(propertiesData.cart);
              } else if (cartItems) {
                let newCartItems = propertiesData.cart;
                let existingCartItems = cartItems;
                let existingCartItemsIds = existingCartItems.map((item) => item.id);
                newCartItems = newCartItems.filter((item) => !existingCartItemsIds.includes(item.id));
                setCartItems([...existingCartItems, ...newCartItems]);
              }
            }
          } else {
            console.warn('Properties data is missing or invalid:', propertiesData);
          }
        } catch (propertiesError) {
          console.error('Error fetching properties:', propertiesError);
          // Don't log out for properties fetch error
        }
      } else {
        // No authentication token found
        console.log('No auth token found, setting unauthenticated state');
        setIsAuthenticated(false);
        setUser(null);
      }
    } catch (error) {
      console.error('Authentication error:', error);
      // Reset authentication state if there's an error
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);
  useEffect(() => {
    const handleVisibilityChange = () => {
      // When the page becomes visible again (user returns to tab)
      if (document.visibilityState === 'visible') {
        if (window.location.pathname === '/cart') {
          checkAuth();
        }
      }
    };

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAuthenticated]);
  const logout = () => {
    authService.logout();
    setIsAuthenticated(false);
    setUser(null);
    setOrders([]);
    setProperties([]);
  };

  const removeFromCart = async (itemId) => {
    const response = await cartService.removeFromCart(0, itemId);
    if (!response?.status) return false;
    if (response.cart) {
      setCartItems(response.cart);
    } else {
      setCartItems((current) => {
        const updatedCart = { ...(current || {}) };
        delete updatedCart[itemId];
        return updatedCart;
      });
    }
    if (response.order_schedule) setOrderSheduled(response.order_schedule);
    return true;
  };

  const onUpdateCart = async (itemId, quantity) => {
    //
    getOrders();
  }

  const toggleSidebar = () => {
    setSidebarOpen(prevState => !prevState);
  };


  if (loading) {
    return <LoadingSpinner />;  // 
  }
  const refreshProperties = async () => {
    checkAuth()
    getOrders();
  }


  return (
    <Router>
      {isAuthenticated ? (
        <CartProvider >
          <div className="flex flex-col min-h-screen">
            <div className="flex flex-1">
              <Sidebar isOpen={sidebarOpen} serviceMode={serviceMode} toggleSidebar={toggleSidebar} logout={logout} isAdmin={user?.role === "admin"} productCount={productCount} orderStats={orderStats} />
              <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100">
                <Header
                  toggleSidebar={toggleSidebar}
                  user={user}
                  logout={logout}
                  serviceMode={serviceMode}
                  setServiceMode={setServiceMode}
                  cartItems={cartItems}
                  appName={config.APP_NAME}
                />
                <ImpersonationBanner onStopImpersonation={() => { }} />
                <FloatingCart cartItems={cartItems} properties={properties} refreshProperties={refreshProperties} setCartItems={setCartItems} removeFromCart={removeFromCart} position="bottom" />
                <Routes>
 
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/admin/all-products" element={<ProductList setProductCount={setProductCount} />} />
                  <Route path="/admin/products/categories" element={<CategoryList />} />
                  <Route path="/admin/categories" element={<CategoryList />} />
                  <Route path="/admin/contact-forms" element={<ContactFormsList />} />

                  <Route path="/admin/all-packs" element={<PacksList setProductCount={setProductCount} />} />
                  <Route path="/admin/all-users" element={<UsersList setProductCount={setProductCount} />} />
                  <Route path="/admin/waiting-users" element={<UsersList status={0} setProductCount={setProductCount} />} />
                  <Route path="/admin/roles" element={<RoleList />} />
                  <Route path="/profile" element={<UserProfile />} />

                  <Route path="/admin/permissions" element={<PermissionList />} />

                  <Route path="/admin/all-orders" element={<OrdersPage />} />
                  <Route path="/admin/messages" element={<AdminMessaging />} />
                  <Route path="/admin/messages/inbox" element={<AdminMessaging />} />
                  <Route path="/admin/user-groups" element={<AdminUserGroups />} />
                  <Route path="/admin/reports/sales" element={<SalesReport />} />
                  <Route path="/admin/properties" element={<AdminPropertiesPage properties={properties} data={otherPropertiyData} isAdminOrImpersonating={isAdminOrImpersonating} orderSheduled={orderSheduled} removeFromCart={removeFromCart} orders={ordersData} refreshProperties={refreshProperties} setCartItems={setCartItems} />} />
                  <Route path="/admin/payments" element={<SimplifiedPaymentManagement />} />  {/* Add this line */}
                  <Route path="/admin/invoices" element={<InvoicesPage />} />
                  <Route path="/admin/integrations/xero" element={<XeroIntegrationPage />} />
                  <Route path="/admin/notification-settings" element={<NotificationSettingsPage />} />
                  <Route path="/admin/stripe-settings" element={<StripeSettingsPage />} />


                  <Route path="/" element={isAdmin() ? <AdminDashboard /> : <Dashboard properties={properties} data={otherPropertiyData} orders={ordersData} refreshProperties={refreshProperties} />} />
                  <Route path="/properties" element={<Properties properties={properties} isAdminOrImpersonating={isAdminOrImpersonating} orderSheduled={orderSheduled} data={otherPropertiyData} removeFromCart={removeFromCart} orders={ordersData} refreshProperties={refreshProperties} setCartItems={setCartItems} />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/inbox" element={<Inbox />} />
                  <Route path="/reports" element={<SalesReport />} />
                  <Route path="/orders/*" element={<OrdersPage />} />
                  <Route path="/cart" element={<Cart isAdminOrImpersonating={isAdminOrImpersonating} onUpdateCart={onUpdateCart} cart={cartItems} orderSchedule={orderSheduled} propertyData={otherPropertiyData} ordersData={ordersData} properties={properties} removeFromCart={removeFromCart}

                  />} />
                  <Route path="/refer" element={<Referer />} />
                  <Route path="*" element={isAdmin() ? <AdminDashboard /> : <Dashboard properties={properties} data={otherPropertiyData} orders={ordersData} refreshProperties={refreshProperties} />} />
                </Routes>
              </main>
            </div>
            <Footer
              appName={config.APP_NAME}
              version={config.VERSION}
              supportEmail={config.SUPPORT_EMAIL}
            />
          </div>
        </CartProvider>
      ) : (
        <Routes>
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/login" element={<Login checkAuth={checkAuth} logout={logout} setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </Router>
  );
};

export default App;
